/* Labels for controls injected by apps (upsell/bundle block) and theme quantity input */
(function(){
  function fix(){
    document.querySelectorAll('.quantity__input:not([aria-label])').forEach(function(i){i.setAttribute('aria-label','Quantity');});
    document.querySelectorAll('select.ufe-variants:not([aria-label])').forEach(function(s){
      var wrap=s.closest('.upsellContent, .upsellBody, .bundleWrapper');
      var name=wrap && wrap.querySelector('.upsellTitle, .ufe-title, a, h3, h4');
      s.setAttribute('aria-label','Choose option' + (name && name.textContent.trim() ? ' for ' + name.textContent.trim().slice(0,60) : ''));
    });
    document.querySelectorAll('.ufe-btn img:not([alt]), .ufe-ico:not([alt])').forEach(function(im){
      if(im.tagName==='IMG'){im.setAttribute('alt','');}else{im.setAttribute('aria-hidden','true');}
    });
    document.querySelectorAll('.ufe-btn:not([aria-label])').forEach(function(b){ if(!b.textContent.trim()) b.setAttribute('aria-label','Add to cart'); });
  }
  if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
  new MutationObserver(function(){clearTimeout(window.__a11yT);window.__a11yT=setTimeout(fix,200);}).observe(document.documentElement,{childList:true,subtree:true});
})();
